import FetchIt from "./FetchIt"

// Case
export const caseDetailsAPI = new FetchIt('/case/case-details/')
const case_list = new FetchIt("/case/get-case-list/")
export const Case = {
    getById: ({ id }) => caseDetailsAPI.get({ params: { case_id: id } }),
    getMany: ({ params, body }) => case_list.post({ params,body })
}

// Disbursement
export const disbursement = new FetchIt('/case/get-disbursement')
const track_disburse = new FetchIt('/case/track-disbursement/')
const update_disbursement = new FetchIt('/case/update-disbursement/')

export const Disbursement = {
    getMany: ({ params }) => disbursement.get({ params }),
    putById: ({ id, payload, case_id }) => track_disburse.put({ url: track_disburse.url + case_id + '/', body: { ...payload, id } }),
    create: ({ payload, case_id })=> update_disbursement.put({ body: payload, url: update_disbursement.url + case_id + '/' })
}

// Repayment
export const repaymentAPI = new FetchIt('/case/get-repayment')
const get_repayment = new FetchIt('/case/get-repayment')
const track_repayment = new FetchIt('/case/track-repayment')

export const Repayment = {
    getMany: ({ params }) => get_repayment.get({ params }),
    putById: ({ id, payload, case_id }) => track_repayment.put({ url: track_repayment.url + case_id + '/', body: { ...payload, id } })
}

